import { walletsStore } from '~/app/modules/processing/stores/wallets';

export default {
  modules: {
    wallets: walletsStore,
  },
};
